// extracted by mini-css-extract-plugin
export var clickableWrapper = "_20-2";
export var placeholderIcon = "_20-3";
export var thumbnailCanvas = "_20-1";
export var thumbnailWrapper = "_20-0";